import React, { useEffect, useRef } from "react";
import styles from "./Features.module.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const features = [
  {
    title: "Industry-Focused Solutions",
    description:
      "ToxBox is your 24/7 AI receptionist for any industry—solving call overload in hospitality, healthcare, retail, and more by handling inquiries and bookings effortlessly.",
    type: "outlined",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "24/7 Availability",
    description:
      "Eliminate off-hour gaps: Your always-on AI supports your business round-the-clock, preventing lost revenue from unanswered calls.",
    type: "filled",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "Easy Setup & Management",
    description:
      "No tech headaches: Set up in minutes and manage effortlessly—perfect for busy teams avoiding complex systems.",
    type: "outlined",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "Smart Call Routing",
    description:
      "End misdirected calls: Automatically route to the right department based on intent, boosting resolution speed by 30%.",
    type: "filled",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "Multi-Language Support",
    description:
      "Break language barriers: Communicate in customers' preferred languages with AI translation, expanding your global reach.",
    type: "outlined",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "Real-Time Transcription & Analytics",
    description:
      "Capture every detail: Transcribe calls instantly, analyze performance, and gain insights to improve agent efficiency and customer engagement.",
    type: "filled",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "CRM Integration",
    description:
      "Streamline workflows: Sync with tools like Salesforce or HubSpot to keep data updated, reducing manual entry errors.",
    type: "outlined",
    logo: require("../../Images/feature1.png"),
  },
  {
    title: "Performance Dashboards",
    description:
      "Track what matters: Measure call quality, lead health, and conversions with detailed analytics—driving data-driven optimizations like ACX's precision engineering.",
    type: "filled",
    logo: require("../../Images/feature1.png"),
  },
];


const Features = () => {
  const containerRef = useRef(null);

 

  const scroll = (direction) => {
    const container = containerRef.current;
    const cardWidth = 344 + 48; // 21.5rem + 3rem gap ≈ 392px

    if (container) {
      container.scrollBy({
        left: direction === "left" ? -cardWidth : cardWidth,
        behavior: "smooth",
      });
    }
  };

  const repeatedFeatures = [...features, ...features];

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container} ref={containerRef}>
        {repeatedFeatures.map((feature, idx) => (
          <div
            key={idx}
            className={`${styles.card} ${
              feature.type === "filled" ? styles.filled : styles.outlined
            }`}
          >
            {/* {feature.logo && <img src={feature.logo} alt={feature.title} className={styles.logo} />} */}
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
      <div className={styles.btnContainer}>
        <button className={styles.scrollBtnLeft} onClick={() => scroll("left")}>
          <FaArrowLeft />
        </button>
        <button className={styles.scrollBtnRight} onClick={() => scroll("right")}>
          <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

export default Features;
